import React from 'react'

export type AgTechNoRecordsPageProps = {
    message: string,
    secondaryMessage?: string,
    action?: { prompt: string, button: () => React.ReactNode }
    classes?: string,
    messageClasses?: string,
    promptClasses?: string,
};

let AgTechNoRecordsPage = (props: AgTechNoRecordsPageProps) => {
    return (
        <div className={`stretched row-based centered container ${props.classes ?? ''}`}>
            <h1 className={`text-md font-semibold font-centered font-height-2 px-6 ${props.messageClasses ?? ''}`}>
                {props.message}
            </h1>
            {props.secondaryMessage && (
                <h2 className={`text-base font-centered mt-3 px-6 ${props.messageClasses ?? ''}`}>
                    {props.secondaryMessage}
                </h2>
            )}
            { props.action ? (
                <>
                    <h1 className={`text-base text-detail font-centered font-height-2 mb-6 px-6 ${props.promptClasses ?? ''}`}>{props.action.prompt}</h1>
                    {props.action ? props.action.button() : null}
                </>
            )
            : null}
        </div>
    )
};

export default AgTechNoRecordsPage;